import { Component, AfterViewInit, AfterViewChecked, ChangeDetectorRef, Inject } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlattener, MatTreeFlatDataSource, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { environment } from './../../environments/environment';
import { SelectionModel } from '@angular/cdk/collections';
import { AppService } from '../modules/shared/app-service/app-service.service';

export class ItemNode {
  children: ItemNode[];
  item: string;
  id: string;
  name: string;
}

export class ItemFlatNode {
  item: string;
  id: string;
  level: number;
  expandable: boolean;

  constructor() { }
}

@Component({
  selector: 'aqualia-organizational-structure',
  templateUrl: './organizational-structure.component.html',
  styleUrls: ['./organizational-structure.component.css']
})
export class OrganizationalStructureComponent implements AfterViewInit, AfterViewChecked {

  treeControl: FlatTreeControl<ItemFlatNode>;
  treeFlattener: MatTreeFlattener<ItemNode, ItemFlatNode>;
  dataSource: MatTreeFlatDataSource<ItemNode, ItemFlatNode>;
  listSelected;
  listSelectedFlatNodes: object[] = new Array();

  dataTree: ItemNode[];

  listExploitations = null;

  isNew: boolean;

  constructor(
    private appService: AppService,
    public dialogRef: MatDialogRef<OrganizationalStructureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: object,
    private cdRef: ChangeDetectorRef) {

    this.listSelected = data;

    if (this.listSelected.length == 0) {
      this.isNew = true;
    } else {
      this.isNew = false;
    }

    const list = this.buildStructure(this.appService.getFromLocal(environment.organizationalStructure));

    this.dataTree = this.buildFileTree(list, 0);

    this.treeControl = new FlatTreeControl<ItemFlatNode>(
      node => node.level, node => node.expandable);

    this.treeFlattener = new MatTreeFlattener(
      this.transformer, node => node.level, node => node.expandable, node => node.children);

    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    this.dataSource.data = this.dataTree;

    this.listExploitations = new SelectionModel(true, this.listSelectedFlatNodes);

  }

  ngAfterViewInit() {
    for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
      if (this.listSelected.includes(this.treeControl.dataNodes[i].id)) {
        this.leafItemSelectionToggle(this.treeControl.dataNodes[i]);
        this.treeControl.expand(this.treeControl.dataNodes[i]);
      }
    }
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  buildStructure(dataStructure): ItemNode[] {

    let list = new Array();

    if (dataStructure != null) {
      for (let country = 0; country < dataStructure.length; country++) {
        list.push({
          'name': dataStructure[country].name,
          'id': '',
          'children': new Array()
        });

        for (let zone = 0; zone < dataStructure[country].lstZones.length; zone++) {
          list[country].children.push({
            'name': dataStructure[country].lstZones[zone].name,
            'id': '',
            'children': new Array()
          });

          for (let delegation = 0; delegation < dataStructure[country].lstZones[zone].lstDelegations.length; delegation++) {
            list[country].children[zone].children.push({
              'name': dataStructure[country].lstZones[zone].lstDelegations[delegation].name,
              'id': '',
              'children': new Array()
            });

            for (let managementUnit = 0; managementUnit < dataStructure[country].lstZones[zone].lstDelegations[delegation].lstManagement.length; managementUnit++) {
              list[country].children[zone].children[delegation].children.push({
                'name': dataStructure[country].lstZones[zone].lstDelegations[delegation].lstManagement[managementUnit].name,
                'id': '',
                'children': new Array()
              });

              for (let contract = 0; contract < dataStructure[country].lstZones[zone].lstDelegations[delegation].lstManagement[managementUnit].lstContratas.length; contract++) {
                list[country].children[zone].children[delegation].children[managementUnit].children.push({
                  'name': dataStructure[country].lstZones[zone].lstDelegations[delegation].lstManagement[managementUnit].lstContratas[contract].name,
                  'id': '',
                  'children': new Array()
                });

                for (let exploitation = 0; exploitation < dataStructure[country].lstZones[zone].lstDelegations[delegation].lstManagement[managementUnit].lstContratas[contract].lstExploitations.length; exploitation++) {
                  list[country].children[zone].children[delegation].children[managementUnit].children[contract].children.push({
                    'name': dataStructure[country].lstZones[zone].lstDelegations[delegation].lstManagement[managementUnit].lstContratas[contract].lstExploitations[exploitation].name,
                    'id': dataStructure[country].lstZones[zone].lstDelegations[delegation].lstManagement[managementUnit].lstContratas[contract].lstExploitations[exploitation].serviceCode
                  });
                }
              }
            }
          }
        }
      }
    }

    return list;
  }

  buildFileTree(list: ItemNode[], level: number): ItemNode[] {
    return list.reduce<ItemNode[]>((accumulator, key) => {
      const value = key.children;
      const node = new ItemNode();
      node.item = key.name;
      node.id = key.id;

      if (value != null) {
        node.children = this.buildFileTree(value, level + 1);
      }

      return accumulator.concat(node);
    }, []);
  }

  private transformer = (node: ItemNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      item: node.item,
      id: node.id,
      level: level
    };
  }

  hasChild = (_: number, node: ItemFlatNode) => node.expandable;

  leafItemSelectionToggle(node: ItemFlatNode): void {
    this.listExploitations.toggle(node);
    this.checkAllParentsSelection(node);
  }

  checkAllParentsSelection(node: ItemFlatNode): void {
    let parent: ItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  getParentNode(node: ItemFlatNode): ItemFlatNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  getLevel = (node: ItemFlatNode) => node.level;

  checkRootNodeSelection(node: ItemFlatNode): void {
    const nodeSelected = this.listExploitations.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every(child =>
      this.listExploitations.isSelected(child)
    );
    if (nodeSelected && !descAllSelected) {
      this.listExploitations.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.listExploitations.select(node);
    }
  }

  descendantsAllSelected(node: ItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every(child =>
      this.listExploitations.isSelected(child)
    );
    return descAllSelected;
  }

  descendantsPartiallySelected(node: ItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.listExploitations.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  itemSelectionToggle(node: ItemFlatNode): void {
    this.listExploitations.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.listExploitations.isSelected(node)
      ? this.listExploitations.select(...descendants)
      : this.listExploitations.deselect(...descendants);

    // Force update for the parent
    descendants.every(child =>
      this.listExploitations.isSelected(child)
    );
    this.checkAllParentsSelection(node);
  }


  closeModal() {
    this.dialogRef.close();
  }
}
